const baseOptions: ApexCharts.ApexOptions = {
  chart: {
    type: 'bar',
    height: 300,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
      borderRadius: 5,
      borderRadiusApplication: 'end',
    },
  },
  dataLabels: {
    enabled: true,
  },
  stroke: {
    show: true,
    width: 2,
  },
  xaxis: {
    categories: [],
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    fontFamily: 'Montserrat, Roboto, Helvetica, Arial, sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    markers: {
      width: 8,
      height: 8,
      radius: 30,
      offsetX: -8,
    },
    itemMargin: {
      horizontal: 24,
      vertical: 16,
    },
  },
};

const distanceChartOptions = {
  ...baseOptions,
  legend: {
    ...baseOptions.legend,
    labels: {
      colors: ['#a7dbd1', '#94F3DA', '#31BAAE', '#038C8C'],
    },
  },
  colors: ['#a7dbd1', '#94F3DA', '#31BAAE', '#038C8C'],
  tooltip: {
    y: {
      formatter(val: number) {
        return `${(val / 1000).toFixed(2)} km`;
      },
    },
  },
  dataLabels: {
    formatter(val: number) {
      return `${(val / 1000).toFixed(2)} km`;
    },
  },
  yaxis: {
    labels: {
      formatter(val: number) {
        return `${(val / 1000).toFixed(2)} km`;
      },
    },
  },
};

const timeChartOptions = {
  ...baseOptions,
  legend: {
    ...baseOptions.legend,
    labels: {
      colors: ['#fede73', '#FEB273', '#FD853A', '#EC4A0A'],
    },
  },
  colors: ['#fede73', '#FEB273', '#FD853A', '#EC4A0A'],
  tooltip: {
    y: {
      formatter(val: number) {
        const hours = val / 3600;
        const minutes = (val - Math.floor(hours) * 3600) / 60;
        return `${Math.floor(hours)}h:${Math.round(minutes)}m`;
      },
    },
  },
  dataLabels: {
    formatter(val: number) {
      const hours = val / 3600;
      const minutes = (val - Math.floor(hours) * 3600) / 60;
      return `${Math.floor(hours)}h:${Math.round(minutes)}m`;
    },
  },
  yaxis: {
    labels: {
      formatter(val: number) {
        const hours = val / 3600;
        const minutes = (val - Math.floor(hours) * 3600) / 60;
        return `${Math.floor(hours)}h:${Math.round(minutes)}m`;
      },
    },
  },
};

export { distanceChartOptions, timeChartOptions };
